export default __webpack_public_path__ + "static/media/zip.103fbbf9.png";